// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/trophy.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/trophy'

import { Icon, type IconComponentProps } from '../icon'

export const TrophyIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
